import './MainContentAreaAll.css';
import { Link } from 'react-router-dom';
import React  ,{useState,setstate} from 'react'
function DATAINCJobComponent(props){ 
    return(
       <div className="ExperienceMainLayout">   
       <br />       
        <div class="card">  
        <div class="card-footer" style={{height:"50px"}}>
             {/* <span className="ExperienceCardFooter-Previous"><Link onClick={() => props.handlechange('')}>Previous</Link></span>
             <span className="ExperienceCardFooter"><Link onClick={() => props.handlechange('TCS')}>Next</Link></span> */}
             <div className="ExperienceCardFooter">
             <Link onClick={() => props.handlechange('Infosys')}>Next</Link>
             </div>
            </div>  
           <h5 class="card-header">
                              <h1 className="MainLabel">Current Job</h1>
                              DATAINC ,Charlotte NC  
                              <br/>May 2021-Present 
                              <br/>Full Stack.Net Developer
           </h5>
           <div class="card-body">
           <h3 style={{textDecoration:"underline"}}>Roles And Responsibilities</h3>
            -Working On MyMerrill BOL site 
           <h3 style={{textDecoration:"underline"}}>Environment</h3>
           Microsoft Visual Studio 2013, ASP.NET, C#, XML, JSON, JavaScript, jQuery, Agile and Scrum, Team Foundation Server 2010,Bit Bucket , Git For  Windows  ,Windows Server 2008 R2/2008 2010             
           </div>            
           
       </div>
       </div>   
    )
}
export default DATAINCJobComponent